module.exports = __webpack_public_path__ + "static/media/green_arrow.c075f69c.svg";